// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VLOj","placeholdersHeader":"styles_placeholdersHeader__zD3L0","editorStyle":"styles_editorStyle__1JZwg","placeholdersBox":"styles_placeholdersBox__2GSlj"};